import React from "react";
import ProductListing from "@/components/ui/product-listing";
import { Italiana } from "next/font/google";
import useTracker from "@/hooks/useTracker";
import { Search_Item_FieldsFragment } from "@/graphql/types/graphql";

const italiana = Italiana({
  subsets: ["latin"],
  weight: "400",
});

interface ProductListProps {
  title?: string;
  items?: Search_Item_FieldsFragment[];
  onClickProduct: (item: Search_Item_FieldsFragment) => void;
}

const ProductList: React.FC<ProductListProps> = ({
  items,
  title,
  onClickProduct,
}) => {
  const { productClickEvent } = useTracker();

  const handleProductClick = (
    item: Search_Item_FieldsFragment,
    index: number
  ) => {
    productClickEvent({
      position: index,
      product_id: item.id,
      product_name: item.name,
      brand: item.brand,
      retailer: item.retailer,
      price: item.price,
      original_price: item.originalPrice || 0,
      seo_url: item.seoURL,
      section_title: title,
    });

    if (onClickProduct) onClickProduct(item);
  };

  return (
    <>
      <div className="product-list-wrapper">
        {title && (
          <h2 className={`${italiana.className} product-list-title`}>
            {title}
          </h2>
        )}
        <div className="product-list">
          {items &&
            items.map((item, index) => (
              <div
                key={item.id}
                className="product"
                onClick={() => handleProductClick(item, index)}
              >
                <ProductListing item={item} title={title} index={index} />
              </div>
            ))}
        </div>
      </div>
      <style jsx>{`
        .product-list-wrapper {
          width: 100%;

          .product-list-title {
            color: #191919;
            font-size: 36px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;

            margin-bottom: 24px;
          }

          .product-list {
            width: 100%;
            display: flex;
            flex-wrap: wrap;

            .product {
              width: 23%;
              cursor: pointer;
              margin-bottom: 56px;
              margin-right: 2.6%;

              &:nth-child(4n) {
                margin-right: 0;
              }
            }
          }
        }

        @media (max-width: 768px) {
          .product-list-wrapper {
            .product-list-title {
              font-size: 24px;
            }

            .product-list {
              justify-content: space-between;
              .product {
                width: calc(50% - 8px);
                margin-left: 0;
                margin-right: 0;
                margin-bottom: 24px;
              }
            }
          }
        }
      `}</style>
    </>
  );
};

export default ProductList;
